import MarkdownPage from '../../components/MarkdownPage';

import IntegrationGuideContent from '../../content/providers/integrationGuide.mdx';

export default function ProviderIntegrationGuide(): JSX.Element {
  return MarkdownPage(IntegrationGuideContent);
}

